import { RelationalActionParameter } from "../../../../domain/document/items";
import { RelationalActionKinds } from "../../../../domain/document";

/**
 * 本来はapi側にあったほうがよい実装だが、仕様がはっきしていなくて開発の効率が悪いので、
 * 暫定的にフロントエンド側で値の抽出をしている
 */
export class RelationalActionExtractor {
  public static extractScriptExecuteParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.ScriptLinkOutput);
  }

  public static extractDesignatedDoctorNumberType(actions: RelationalActionParameter[]): string {
    if (!actions) { return null; }
    const found = actions.find(a => a.kind === RelationalActionKinds.DesignateDoctor);
    return found ? found.value : null;
  }

  public static extractTextPasteParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.TextPaste);
  }

  public static extractParentAlertParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.ParentAlert);
  }

  public static extractCalculateParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.Calculate);
  }

  public static extractMksTemplateFormats(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.MksTemplateFormat);
  }

  public static extractDynamicTemplateFormats(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.DynamicTemplateFormat);
  }

  public static extractNumberingIdentifierSourceParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.NumberingIdentifier);
  }
  
  public static extractUserDefineLinkParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.UserDefineLinkValue);
  }

  public static extractUserDefineSearchParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.UserDefineSearch);
  }

  public static extractObjectLinkParameters(actions: RelationalActionParameter[]): RelationalActionParameter[] {
    return this.extractParameters(actions, RelationalActionKinds.ObjectLink);
  }

  private static extractParameters(actions: RelationalActionParameter[], kind: RelationalActionKinds): RelationalActionParameter[] {
    if (!actions) { return []; }
    return actions.filter(a => a.kind === kind);
  }
}
